/** Angular Imports */
import { Injectable, inject } from '@angular/core';

/** rxjs Imports */
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

/** Custom Services */
import { ClientsService } from '../clients.service';

/**
 * Client datatables resolver.
 */
@Injectable()
export class ClientDatatablesResolver {
  private clientsService = inject(ClientsService);

  /**
   * Returns the Client datatables.
   * @returns {Observable<any>}
   */
  resolve(): Observable<any> {
    return this.clientsService.getClientDatatables().pipe(catchError(() => of([])));
  }
}